<template>
  <div class="gallery" :class="isPortfolioPage ? 'adjust' : ''" v-if="gallery.length">
    <div class="inner">
      <!-- <div class="heading">Gallery</div> -->
      <a class="gallery-link photos" :href="image.image" v-for="image in gallery" :key="image._id">
        <img :src="image.image" :alt="image.alt" :title="image.alt" />
        <span
          :title="image.alt"
          class="gallery-image"
          :style="{ backgroundImage: backgroundImage(image.image) }"
        ></span>
        <span class="gallery-desc" v-if="image.description">{{ image.description }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { LuminousGallery } from "luminous-lightbox"
import { mapGetters, mapState } from "vuex"

export default {
  data: function() {
    return {}
  },
  methods: {
    backgroundImage: function(url) {
      if (!url) return ""

      return (
        "url('" +
        url
          .replace(" ", "%20")
          .replace("(", "%28")
          .replace(")", "%29")
          .replace("&", "%26")
          .replace("'", "%27") +
        "')"
      )
    }
  },
  computed: {
    ...mapState(["portfolioPage", "page"]),
    ...mapGetters(["isPortfolioPage"]),
    gallery() {
      if (!this.portfolioPage) return []
      if (!this.portfolioPage.gallery) return []
      if (!this.portfolioPage.gallery.length) return []

      var gallery = this.portfolioPage.gallery
      if (!this.isPortfolioPage) gallery = gallery.filter(i => i.services && i.services.indexOf(this.page.ItemID) > -1)

      return gallery
    }
  },
  mounted: function() {
    setTimeout(function() {
      new LuminousGallery(
        document.querySelectorAll(".photos"),
        {
          arrowNavigation: true
        },
        {
          caption: function(trigger) {
            return trigger.querySelector("img").getAttribute("title")
          }
        }
      )
    }, 500)
  }
}
</script>

<style scoped>
.adjust {
  margin-top: -5rem;
  margin-bottom: 3rem;
}
.gallery .inner {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding-bottom: 5rem;
  gap: 3rem;
}
.gallery-link img {
  display: none;
}
.gallery-link {
  border-bottom: 0.5rem solid #c1d62f;
}
.gallery-image {
  display: block;
  width: 100%;
  height: 20rem;
  background-size: cover;
  background-position: center center;
}
.gallery-desc {
  padding: 2rem;
  width: 100%;
  display: block;
  font-size: 2rem;
}
@media screen and (max-width: 650px) {
  .gallery .inner {
    grid-template-columns: repeat(2, 1fr);
  }
  .gallery-image {
    height: 15rem;
  }
}
@media screen and (max-width: 400px) {
  .gallery .inner {
    grid-template-columns: repeat(1, 1fr);
  }
  .gallery-image {
    height: 10rem;
  }
}
</style>
